import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

// Material MDC Imports
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatMenuModule } from "@angular/material/menu";
import { BaseSearchResultsComponent } from "../base-search-results.component";
import { SearchResultCardComponent } from "../result-card/search-result-card.component";
import { IntersectObserverDirective } from "../../../../shared/directives/observer/intersect-observer.directive";
import { SearchDisplayMode } from "../../../model";

/**
 * Grid display component for search results
 * Displays search results in a responsive grid layout with Material Design
 */
@Component({
  selector: "app-grid-search-results",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./grid-search-results.component.html",
  styleUrls: ["./grid-search-results.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    SearchResultCardComponent,
    MatTooltipModule,
    MatMenuModule,
    IntersectObserverDirective,
  ],
})
export class GridSearchResultsComponent extends BaseSearchResultsComponent {
  @Input() parentSize!: { width: number; height: number };

  /**
   * Handles fit-to-item event from card and switches to MAP mode.
   * @param index Index of the card to scroll to in the list
   */
  onFitToItem(index: number): void {
    this.searchQueryService.setScrollToIndex(index);
    this.searchQueryService.setSearchDisplayMode(SearchDisplayMode.MAP);
  }
}
